import helper from '../validation/helper';
/**
 * Go through all the fields present in the layout and call the visitorCallback function with that field
 * If the visitorCallback function returns true, the visiting is stopped (performance reason)
 * @param {import('./types').EcrionFormState} state
 * @param {(field:import('../logic/types').EcrionFormField) => boolean} visitorCallback
 */

var visit = function visit(state, visitorCallback) {
  var stopVisiting = false;
  state.layout.pages.forEach(function (pageLayoutId) {
    if (stopVisiting) return;
    var pageLayout = state.layout.containers[pageLayoutId];
    var pageFields = helper.findVisibleFields(pageLayout, state);
    pageFields.forEach(function (fieldId) {
      if (stopVisiting) return;
      stopVisiting = stopVisiting || visitorCallback(state.fields[fieldId]);
    });
  });
};

export default {
  visit: visit
};